import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Select } from '@ngxs/store';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';
import { VISIBLE_SECURE_MESSAGE_GROUPS } from '~app/messages/secure-message-categories';
import { SecureMessagesNavService } from '~app/messages/services/secure-messages-nav.service';
import { YearInfo } from '~app/inscription/store/year-selection/year-selection.model';
import { YearSelectionState } from '~app/inscription/store/year-selection/year-selection.state';
import { MenuItems } from '../../../menu-items/menu-items';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: [],
    standalone: false
})
export class AppSidebarComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public config: PerfectScrollbarConfigInterface = {};
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  @Select(YearSelectionState.yearsInfos)
  yearsInfos$: Observable<YearInfo[]>
  yearsInfos: YearInfo[];
  
  readonly secureMessageGroups = VISIBLE_SECURE_MESSAGE_GROUPS;

  @Output()
  itemclicked = new EventEmitter();

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    public secureMessagesNav: SecureMessagesNavService,
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 1099px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    // Load unread counters once the messages menu is available for this user.
    this.menuItems.mainMenuItems$
      .pipe(
        map(items => items.some(i => i.state === 'messages')),
        distinctUntilChanged(),
        filter(hasMessages => hasMessages),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.secureMessagesNav.refresh());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onItemClick() {
    this.itemclicked.emit('clicked');
  }
}
